import * as React from "react";
import { ClickArea } from "../../helpers/click-area/click-area.mjs";
import { Icon } from "../../icon/icon/icon.mjs";
import { Image } from "../../image/image.mjs";
import { AccordionItemContext } from "../accordion-item/accordion-item-context.mjs";
const _AccordionHeader = class _AccordionHeader extends React.Component {
  getIcon() {
    if (!this.context.icon) {
      return null;
    }
    if (typeof this.context.icon === "string") {
      return /* @__PURE__ */ React.createElement("div", { className: "accordion__icon-wrapper" }, /* @__PURE__ */ React.createElement(Icon, { className: "accordion__icon", modifiers: this.context.icon }));
    } else {
      return /* @__PURE__ */ React.createElement("div", { className: "accordion__image-wrapper" }, /* @__PURE__ */ React.createElement(Image, { ...this.context.icon, className: "accordion__image" }));
    }
  }
  renderArrow() {
    return /* @__PURE__ */ React.createElement("div", { className: "accordion__arrow" }, /* @__PURE__ */ React.createElement(Icon, { modifiers: "#arrow-down" }));
  }
  render() {
    return /* @__PURE__ */ React.createElement(ClickArea, null, /* @__PURE__ */ React.createElement("div", { className: "accordion__header", id: "".concat(this.context.id, "-header") }, this.getIcon(), /* @__PURE__ */ React.createElement("div", { className: "accordion__header-content-wrapper" }, this.props.children), this.renderArrow()));
  }
};
_AccordionHeader.contextType = AccordionItemContext;
let AccordionHeader = _AccordionHeader;
export {
  AccordionHeader
};
